import { FailedRule, JSONRuleOperators } from '../types';

const operatorsMap: Record<JSONRuleOperators, (actual: any, expected: any) => boolean> = {
  [JSONRuleOperators.Equal]: (actual, expected) => actual === expected,
  [JSONRuleOperators.NotEqual]: (actual, expected) => actual !== expected,
  [JSONRuleOperators.GT]: (actual, expected) => actual > expected,
  [JSONRuleOperators.GTI]: (actual, expected) => actual >= expected,
  [JSONRuleOperators.LT]: (actual, expected) => actual < expected,
  [JSONRuleOperators.LTI]: (actual, expected) => actual <= expected,
  [JSONRuleOperators.In]: (actual, expected) => Array.isArray(expected) && expected.includes(actual),
  [JSONRuleOperators.NotIn]: (actual, expected) => Array.isArray(expected) && !expected.includes(actual),
  [JSONRuleOperators.Length]: (actual, expected) => actual?.length === expected,
};

export const evaluateCondition = (operator: JSONRuleOperators, actual: any, expected: any) => {
  const operation = operatorsMap[operator];
  return operation ? operation(actual, expected) : false;
};

export function groupFailedConditions(
  failedConditions: Record<string, Omit<FailedRule, 'humanReadableReason' | 'fact'>[]>
) {
  const explanations: FailedRule[] = [];

  for (const [fact, conditions] of Object.entries(failedConditions)) {
    const actual = conditions[0].actual;
    const ops = conditions.map(({ operator }) => operator);

    const values = Object.fromEntries(conditions.map(c => [c.operator, c.expected]));

    if (ops.includes(JSONRuleOperators.GTI) && ops.includes(JSONRuleOperators.LTI)) {
      explanations.push({
        fact,
        actual,
        operator: 'between',
        expected: [values.greaterThanInclusive, values.lessThanInclusive],
      });
    } else if (ops.includes(JSONRuleOperators.GT) && ops.includes(JSONRuleOperators.LT)) {
      explanations.push({ fact, actual, operator: 'between', expected: [values.greaterThan, values.lessThan] });
    } else if (ops.includes(JSONRuleOperators.GT)) {
      explanations.push({ fact, actual, operator: JSONRuleOperators.GT, expected: values.greaterThan });
    } else if (ops.includes(JSONRuleOperators.LT)) {
      explanations.push({ fact, actual, operator: JSONRuleOperators.LT, expected: values.lessThan });
    } else {
      for (const cond of conditions) {
        explanations.push({
          fact,
          actual: cond.actual,
          operator: cond.operator,
          expected: cond.expected,
        });
      }
    }
  }

  return explanations;
}
